import {
  UserDetailsType,
  UserProfile,
  UserSessionObjectType,
  altJourneyTheme,
} from './types';

export const USERSESSIONOBJECT: UserSessionObjectType = {
  userId: null,
  accessToken: null,
  refreshToken: null,
  userConsentActive: null,
  referenceId: null,
  accounts: null,
  templateType: null,
  pfmType: null,
  trackingId: null,
  isLoanJourneyEnabled: false,
  tenant: null,
  journeyType: '',
  isWhiteListed: false,
  sessionId: null,
  isNewUser: true,
  trendsVisible: false,
  existingUserJourneyStartedOnce: false,
  altJourney: '',
  altJourneyTheme: altJourneyTheme.YesGlory,
  sdkFlowSelection: false,
  mahindraTheme: '',
  maskedMobileNumber: null,
  userProfile: null,
};

export const getExistingUserJourneyStartedOnce = () => {
  return USERSESSIONOBJECT.existingUserJourneyStartedOnce;
};

export const setExistingUserJourneyStartedOnce = (is: boolean) => {
  USERSESSIONOBJECT.existingUserJourneyStartedOnce = is;
};

export const setAltJourney = (type: string) => {
  USERSESSIONOBJECT.altJourney = type;
};

export const getAltJourney = () => {
  return USERSESSIONOBJECT.altJourney;
};

export const setAltJourneyTheme = (theme: altJourneyTheme) => {
  USERSESSIONOBJECT.altJourneyTheme = theme;
};

export const getAltJourneyTheme = () => {
  return USERSESSIONOBJECT.altJourneyTheme;
};

export const setMahindraThemeMode = (type: string) => {
  USERSESSIONOBJECT.mahindraTheme = type;
};

export const getMahindraThemeMode = () => {
  return USERSESSIONOBJECT.mahindraTheme;
};

export const trendsVisible = () => {
  return USERSESSIONOBJECT.trendsVisible;
};
export const setTrendsVisible = (trendsVisible: boolean) => {
  USERSESSIONOBJECT.trendsVisible = trendsVisible;
};

export const setSessionId = (sessionId: string) => {
  USERSESSIONOBJECT.sessionId = sessionId;
};

export const setIsNewUser = (is: boolean) => {
  USERSESSIONOBJECT.isNewUser = is;
};

export const getIsNewUser = () => {
  return USERSESSIONOBJECT.isNewUser;
};

export const setIsWhiteListed = (isWhiteListed: boolean) => {
  return (USERSESSIONOBJECT.isWhiteListed = isWhiteListed);
};

export const getIsWhiteListed = () => {
  return USERSESSIONOBJECT.isWhiteListed;
};

export const getSessionId = () => {
  return USERSESSIONOBJECT.sessionId;
};

export const setPfmType = (type: string) => {
  USERSESSIONOBJECT.pfmType = type;
};

export const setTrackingId = (trackingId: string) => {
  USERSESSIONOBJECT.trackingId = trackingId;
};

export const setTenant = (tenant: string) => {
  USERSESSIONOBJECT.tenant = tenant;
};

export const getTenant = () => {
  return USERSESSIONOBJECT.tenant;
};

export const getTrackingId = () => {
  return USERSESSIONOBJECT.trackingId;
};
export const getPfmType = () => {
  return USERSESSIONOBJECT.pfmType;
};

export const setTempateType = (template: string) => {
  USERSESSIONOBJECT.templateType = template;
};

export const getTemplateType = () => {
  return USERSESSIONOBJECT.templateType;
};

export const getAccessToken = () => {
  return USERSESSIONOBJECT.accessToken;
};
export const getRefreshToken = () => {
  return USERSESSIONOBJECT.refreshToken;
};
export const areApprovedConsentsAvailable = () => {
  return USERSESSIONOBJECT.userConsentActive;
};

export const getIsLoanJourney = () => {
  return USERSESSIONOBJECT.isLoanJourneyEnabled;
};
export const setIsLoanJourney = (loanJourney: boolean) => {
  USERSESSIONOBJECT.isLoanJourneyEnabled = loanJourney;
};
export const setJourneyType = (journeyType: string) => {
  USERSESSIONOBJECT.journeyType = journeyType;
};
export const getUserId = () => {
  return USERSESSIONOBJECT.userId;
};
export const setUserId = (userId: string) => {
  USERSESSIONOBJECT.userId = userId;
};
export const setAccessToken = (accessToken: string) => {
  USERSESSIONOBJECT.accessToken = accessToken;
};
export const setRefreshToken = (refreshToken: string) => {
  USERSESSIONOBJECT.refreshToken = refreshToken;
};
export const setIsApprovedConsentsAvailable = (userConsentActive: boolean) => {
  USERSESSIONOBJECT.userConsentActive = userConsentActive;
};

export const setAreApprovedConsentsAvailable = (userConsentActive: boolean) => {
  USERSESSIONOBJECT.userConsentActive = userConsentActive;
};

export const storeUserSessionObject = (userDetails: UserDetailsType) => {
  setAccessToken(userDetails.accessToken);
  setRefreshToken(userDetails.refreshToken);
  setUserId(userDetails.userId);
  setAreApprovedConsentsAvailable(userDetails.userConsentActive);
};

export const setReferenceId = (referenceId: string) => {
  USERSESSIONOBJECT.referenceId = referenceId;
};

export const getReferenceId = () => {
  return USERSESSIONOBJECT.referenceId;
};

export const setSdkFlowSelection = (sdkFlowSelection: boolean) => {
  USERSESSIONOBJECT.sdkFlowSelection = sdkFlowSelection;
};

export const getSdkFlowSelection = () => {
  return USERSESSIONOBJECT.sdkFlowSelection;
};

export const setMaskedMobileNumber = (maskedMobileNumber: string) => {
  USERSESSIONOBJECT.maskedMobileNumber = maskedMobileNumber;
};

export const getMaskedMobileNumber = () => {
  return USERSESSIONOBJECT.maskedMobileNumber;
};

export const setUserProfile = (userProfile: UserProfile) => {
  USERSESSIONOBJECT.userProfile = userProfile;
};

export const getUserProfile = () => {
  return USERSESSIONOBJECT.userProfile;
};
